import clsx from 'clsx';
import React, { useState } from 'react';

type TooltipVariant = 'default' | 'light';

type TooltipProps = {
  content: string;
  variant?: TooltipVariant;
  className?: string;
  children: React.ReactNode;
};

const variantStyles: Record<TooltipVariant, string> = {
  default: 'bg-gray-900 text-white',
  light: 'bg-white text-gray-900 border border-gray-200',
};

export const Tooltip: React.FC<TooltipProps> = ({ content, variant = 'default', className, children }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div
      className={clsx('relative inline-block', className)}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && (
        <div
          className={clsx(
            'absolute bottom-full left-1/2 -translate-x-1/2 mb-2 z-50 px-3 py-2 text-sm rounded-lg shadow-lg w-max max-w-[min(100vw,24rem)] break-words whitespace-normal',
            variantStyles[variant]
          )}
        >
          {content}
        </div>
      )}
    </div>
  );
};
